import { css } from 'lit';

var css_248z = css`:host .textarea-resize-none{resize:none}:host .textarea-resize-vertical{resize:vertical}`;

export { css_248z as default };
//# sourceMappingURL=sgds-textarea2.js.map
